/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Composerhint2Inputs */

const en_coinvestments_messages_composerhint2 = /** @type {(inputs: Coinvestments_Messages_Composerhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<kbd>Enter</kbd> to send, <kbd>Shift</kbd>+<kbd>Enter</kbd> for a new line`)
};

/**
* | output |
* | --- |
* | "<kbd>Enter</kbd> to send, <kbd>Shift</kbd>+<kbd>Enter</kbd> for a new line" |
*
* @param {Coinvestments_Messages_Composerhint2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_composerhint2 = /** @type {((inputs?: Coinvestments_Messages_Composerhint2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Composerhint2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_composerhint2(inputs)
});
export { coinvestments_messages_composerhint2 as "coInvestments_messages_composerHint" }